export function FormattedCommaSeparatedValue(value: number | string | null):string {
    if (value === null || value === undefined) {
        return '';
    }
    if(typeof value ==='string'){
        const parsedValue = parseFloat(value);
        // eslint-disable-next-line no-restricted-globals
        if(!isNaN(parsedValue)){
            value = parsedValue;
        }
    }
    return value.toLocaleString('en-US');    
}